import { RoleType } from '@feature/security';

export const localAccountAdminRoles = [
  RoleType.ADMIN,
  RoleType.UNIVERSITY_ADMIN,
] as const satisfies readonly RoleType[];

export function isLocalAccountAdminRole(role: RoleType) {
  return (localAccountAdminRoles as readonly RoleType[]).includes(role);
}
